module.exports = __webpack_public_path__ + "img/bgImg3.868f30f4.png";